import { toast } from 'react-toastify';
import { useStartDraftMutation } from './useDraftMutations';

export function useStartDraftAction(templateId: string) {
  const mutation = useStartDraftMutation(templateId);
  const start = (fromVersionId?: string, onStarted?: () => void) =>
    mutation.mutate(fromVersionId, {
      onSuccess: onStarted,
      onError: (error) => toast.error((error as Error).message),
    });
  return { start, isStarting: mutation.isPending };
}
